<template>
  <v-app>
    <v-overlay
      opacity="0.82"
      :model-value="overlay"
      class="align-center justify-center"
    >
      <div class="loader-card">
        <img width="96" height="96" :src="logo" class="rotate-animation" alt="3D Auto Centering">
        <span>3D Auto Centering</span>
      </div>
    </v-overlay>

    <app-bar></app-bar>
    <footer-component></footer-component>
  </v-app>
</template>

<script>
import AppBar from "@/components/AppBar.vue";
import Logo from "../public/Images/3dCenteringLogo.svg";
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: 'App',
  components: {
    FooterComponent,
    AppBar,
  },

  data() {
    return {
      overlay: false,
      logo: Logo,
      language: null,
    };
  },

  mounted() {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      this.$i18n.locale = storedLanguage;
    }

    this.language = this.$i18n.locale;
    localStorage.setItem('language', this.language);

    this.overlay = true;
    setTimeout(() => {
      this.overlay = false;
    }, 1000);
  },
};
</script>

<style>
:root {
  --site-ink: #0b0d10;
  --site-panel: #14171c;
  --site-panel-soft: #1e232b;
  --site-paper: #f5f0e8;
  --site-muted: #aeb6c2;
  --site-line: rgba(255, 255, 255, 0.14);
  --site-orange: #ff7a00;
  --site-orange-strong: #f15a24;
  --site-green: #2fd07f;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--site-ink);
}

#app {
  min-height: 100vh;
  color: white;
  font-family: "Roboto", Arial, sans-serif;
}

a {
  color: inherit;
}

.site-page {
  min-height: calc(100vh - 72px);
  background:
    radial-gradient(circle at top left, rgba(255, 122, 0, 0.17), transparent 34rem),
    linear-gradient(135deg, #090b0e 0%, #161a20 46%, #07080a 100%);
  padding-top: 72px;
}

.site-container {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
}

.section-eyebrow {
  margin: 0 0 10px;
  color: var(--site-orange);
  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.section-title {
  margin: 0;
  color: white;
  font-size: clamp(2rem, 5vw, 4.4rem);
  font-weight: 900;
  line-height: 0.98;
  text-transform: uppercase;
}

.section-copy {
  max-width: 720px;
  margin: 18px 0 0;
  color: #d7dde4;
  font-size: clamp(1rem, 1.8vw, 1.18rem);
  line-height: 1.7;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.site-button {
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0 18px;
  color: white;
  font-weight: 900;
  text-decoration: none;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.site-button:hover {
  transform: translateY(-2px);
}

.site-button.primary {
  background: linear-gradient(135deg, var(--site-orange), var(--site-orange-strong));
  box-shadow: 0 14px 34px rgba(241, 90, 36, 0.32);
}

.site-button.secondary {
  border-color: var(--site-line);
  background: rgba(255, 255, 255, 0.08);
}

.glass-panel {
  border: 1px solid var(--site-line);
  border-radius: 8px;
  background: rgba(18, 21, 27, 0.82);
  box-shadow: 0 24px 90px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(14px);
}

.loader-card {
  display: grid;
  gap: 14px;
  place-items: center;
  border: 1px solid var(--site-line);
  border-radius: 8px;
  padding: 22px 28px;
  background: rgba(8, 10, 12, 0.78);
  color: white;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
    filter: grayscale(1);
  }
  to {
    transform: rotate(360deg);
    filter: grayscale(0);
  }
}

.rotate-animation {
  animation: rotate 1.7s linear infinite;
}

@media (max-width: 720px) {
  .site-page {
    padding-top: 64px;
  }

  .site-container {
    width: min(100% - 24px, 1180px);
  }

  .action-row,
  .site-button {
    width: 100%;
  }
}
</style>
